import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Tag} from 'primereact/tag';

const providerNames = {MAILERLITE: 'MailerLite', MAILCHIMP: 'Mailchimp', BREVO: 'Brevo'};
const statusSeverity = {DRAFT: 'info', SYNCING_RECIPIENTS: 'warning', READY: 'success', PROVIDER_DRAFT: 'info', SCHEDULED: 'warning', SENDING: 'warning', SENT: 'success', FAILED: 'danger'};

const CampaignListComponent = ({t}) => {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const headers = {Authorization: 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')};
  useEffect(() => {
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/crm-campaign?sort=id&direction=desc&item_per_page=200', {headers})
      .then(({data}) => setItems(data.data.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
      .finally(() => setLoading(false));
  }, [window.App.state.rerenderCampaignList]);

  return <DataTable value={items} loading={loading} emptyMessage={t('noResults')} responsiveLayout="scroll" stripedRows>
    <Column field="name" header={t('columnName')} sortable/>
    <Column field="subject" header={t('newsletterSubject')} body={row => row.subject || '—'}/>
    <Column header={t('newsletterProvider')} body={row => providerNames[row.newsletter_connection?.provider] || '—'}/>
    <Column header={t('newsletterRecipients')} body={row => row.recipient_count || 0}/>
    <Column header={t('newsletterMetric.opens')} body={row => row.newsletter_statistics?.opens ?? '—'}/>
    <Column header={t('newsletterMetric.clicks')} body={row => row.newsletter_statistics?.clicks ?? '—'}/>
    <Column field="newsletter_status" header={t('status')} body={row => <Tag severity={statusSeverity[row.newsletter_status]} value={t('newsletterStatus.' + (row.newsletter_status || 'DRAFT'))}/>}/>
    <Column body={row => <Button icon="pi pi-pencil" label={t('newsletterOpenCampaign')} onClick={() => history.push('/crm/campaign/update/' + row.id)}/>} className="p-text-right"/>
  </DataTable>;
};
export default withTranslation('common')(CampaignListComponent);
